module.exports = __webpack_public_path__ + "static/img/peo05@2x.990be389.png";